import { useState, useEffect } from "react";
import HomeHeader from "layouts/homeHeader";
import HomeNavbar from "layouts/homeNavbar";
import BackgroundImage from "assets/images/header.webp";
import SettingsIcon from "assets/icons/setting.svg";
import ChatIcon from "assets/icons/chat.svg";
import AnnouncementIcon from "assets/icons/announcement.svg";
import HamburgerIcon from "assets/icons/hamburger.svg";
import styles from "./style.module.scss";
import SearchIcon from "assets/icons/search.svg";
import Button from "components/UI/Button";
import { useParams } from 'react-router';
import { Link, useNavigate } from "react-router-dom";
import { InstallationModelResponse } from "types";
import axios from "axios";
import { useKeycloak } from "@react-keycloak/web";
import LoaderSpinner from "../../components/UI/LoaderSpinner/LoaderSpinner";
import ReactPaginate from "react-paginate";
import NextIcon from "assets/icons/pagination-next.svg";
import PrevIcon from "assets/icons/pagination-prev.svg";
import "./paginate.css";
import { locationController } from "utils/locationhelper";
import AuthService from "services/AuthService";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'



const SayacVerileri = () => {

  const params = useParams<any>();
  const { keycloak } = useKeycloak();
  const [sayacList,setInstallations] = useState<InstallationModelResponse>();
  const [searchedVal, setSearchedVal] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);

  const auth = new AuthService(keycloak);

  let companyId = locationController();

 
  useEffect(() => {
    getInstallations()

  }, [pageNumber]);


     // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    setPageNumber(event.selected + 1);
  };

  const getInstallations = async() => {
    setIsLoading(true);
    
    auth.axios(`/InstallationOperations/GetInstallationInfo`, null,
    { 
        email: keycloak?.tokenParsed?.email,
        companyId : companyId,
        pageSize: itemsPerPage,
        page: searchedVal != "" ? 1 : pageNumber,
        tesisatNo: searchedVal != "" ? searchedVal : null    
    })
    .then(response => {     
      
      setIsLoading(false);

      if (response.data.success === true) {
        //data.permission kontrolu eklenecek backend'e (true/false)
        //history.push(/404)
          setInstallations(response.data.data);
          setPageCount(Math.ceil(response.data.totalCount / itemsPerPage));
      }
      else {    
        if(response.data.message){
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored"
         });
        }
      }
    
  
    }).catch(err => {
      setIsLoading(false);

      toast.error(err.response.data.message, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored"
     });

    
    });
    
  }

  return (
    <div className={styles.sayacVerileri}>
      <div className={styles.left}>
        <HomeNavbar />
      </div>
      <ToastContainer/>
      <div className={styles.right}>
        <HomeHeader
          personal="#fff"
          hamburgerIcon={HamburgerIcon}
          announcementIcon={AnnouncementIcon}
          chatIcon={ChatIcon}
          settingsIcon={SettingsIcon}
          title="Sayaç Verileri"
          background={BackgroundImage}
          color={"#fff"}
        />
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.searchTitle}>Tesisat Ara</div>
            <div className={styles.search}>
              <input
                type="text"
                name=""
                id=""
                placeholder="Tesisat numarası girin"
                onChange={(e) => setSearchedVal(e.target.value)}
              />
              <img 
               onClick={() => {
                if(searchedVal != ""){
                  setPageNumber(1)
                }
                getInstallations();
              }}
              src={SearchIcon} alt="icon" />
            </div>
          </div>
          <div className={styles.info}>
            <div className={styles.subTitle}>
              OSOS kapsamında haberleşme ünitesi montajı yapılmış olup veri
              alınan sayaçların verileri paylaşılmaktadır.
            </div>
            <table>
              <thead>
                <tr>
                  <th>Tesisat No</th>
                  <th>Abone Ünvanı</th>
                  <th>Abone Adresi</th>
                  <th>Sayaç Seri No</th>
                  <th>Sayaç Modeli</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
              {isLoading ? <LoaderSpinner /> : 
              sayacList?.map((item) => (
                <tr key={item.id}>
                  <td>{item.tesisatNo}</td>
                  <td>{item.aboneAdiSoyadi}</td>
                  <td>{item.adres}</td>
                  <td>{item.sayacSeriNo}</td>
                  <td>{item.sayacModeli}</td>
                  <td>
                  <Link
                      to={
                        `/tesisat-detaylari/` + item.tesisatNo + `/durum-grafikleri`
                      }
                    >
                    <Button
                      btnType="sendMessage"
                      onClick={() => {
                        //navigate("/tesisat-detaylari/durum-grafikleri");
                    }}
                      text="Detayları Görüntüle"
                      color="#fff"
                      width="149px"
                    />
                  </Link>
                  </td>
                </tr>
              ))
              }
              </tbody>
            </table>
          </div>

          <div className="pagination-container">
        <ReactPaginate
          breakLabel="..."
          nextLabel={<img src={NextIcon} alt="icon" />}
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel={<img src={PrevIcon} alt="icon" />}
          className="pagination"
          //pageIndex
          forcePage={pageNumber-1}
          activeClassName="pagination-active-item"
          containerClassName="pagination-container"
          pageClassName="pagination-item"
          previousClassName="pagination-item-previous"
          nextClassName="pagination-item-next"
          breakClassName="pagination-item-break"
        />
      </div>
                   
        </div>
      </div>
    
    
    </div>
    
  );
};

export default SayacVerileri;
